export const fontFamilies = {
  body: 'IBMPlexSans',
  heading: 'OatmealPro',
};
